const SportWorkerTasks = {
  MakeMarketGroups: "MakeMarketGroups",
  FormatOutcomesDescription: "FormatOutcomesDescription"
};
export {
  SportWorkerTasks
};
